const defaultCustomerSupportPhone = "+91 90033 30286";
const defaultCustomerSupportWhatsApp = "+91 90439 43995";
const defaultCustomerSupportEmail = "support@carevinco.com";

function getBooleanEnv(value: string | undefined, fallback: boolean) {
  if (!value?.trim()) return fallback;
  return !["false", "0", "no", "off"].includes(value.trim().toLowerCase());
}

function getPhoneHref(value: string) {
  const normalized = value.replace(/[^\d+]/g, "");
  return normalized ? `tel:${normalized}` : "/contact-us";
}

function getWhatsAppHref(value: string) {
  const normalized = value.replace(/\D/g, "");
  return normalized ? `https://wa.me/${normalized}` : "/contact-us";
}

export const customerSupportPhone =
  process.env.NEXT_PUBLIC_CUSTOMER_SERVICE_PHONE ||
  process.env.NEXT_PUBLIC_COMPANY_PHONE ||
  process.env.NEXT_PUBLIC_SUPPORT_PHONE ||
  defaultCustomerSupportPhone;

export const customerSupportWhatsApp =
  process.env.NEXT_PUBLIC_SUPPORT_WHATSAPP ||
  defaultCustomerSupportWhatsApp;

export const customerSupportEmail =
  process.env.NEXT_PUBLIC_SUPPORT_EMAIL ||
  defaultCustomerSupportEmail;

export const customerSupportTelHref = getPhoneHref(customerSupportPhone);
export const customerSupportWhatsAppHref = getWhatsAppHref(customerSupportWhatsApp);
export const customerSupportEmailHref = `mailto:${customerSupportEmail}`;
export const isSiteActive = getBooleanEnv(process.env.NEXT_PUBLIC_SITE_ACTIVE, true);

export function getCustomerSupportTelHref(phone?: string | null) {
  return phone?.trim() ? getPhoneHref(phone) : customerSupportTelHref;
}
